<template>
  <div class="index">
      <!-- <div class="index-header">
          <div class="header-charts">
              <div  class="header-list">
                <div class="scrollhidden">
                <ul>
                    <li  v-for="(item,index) in headerlist"
                        :key="index"
                        :class="{active : current==index}"
                        @click="check(item,index)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
                </div>
              </div>
              <div class="myChart" id="myChart" ref="myChart"></div>
          </div>
          
      </div> -->
      <!-- <div class="search-style">
          <div class="input-style">
              <input placeholder="热门搜索:地区生产总值、规上工业增加值等" v-model="input" @input="inputlist()"/>
              <div class="searchlist" v-if="searchliststatus">
                <ul>
                  <li  v-for="(item,index) in searchlist"
                        :key="index"
                        @click="listcheck(item,index)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
              </div>
              <div class="searchlist" v-if="searchliststatusnone">
                <ul>
                  <li>暂无数据</li>
                </ul>
              </div>
              <div class="search-button">
                <img src="../../assets/img/index-search.png">
              </div>
          </div>
      </div> -->
      <div class="content-tjrc">
        <div class="tjrc-title">
            <img src="../../assets/img/tjrc-icon.png">
            <span>统计热词</span>
        </div>
        <div class="tjrc-zb">
            <ul>
              <li v-for="(item,index) in searchtop"
                        :key="index"
                        herf=""
                        @click="listcheck(item,index)">
                <span>{{item.resName}}</span>
                <span>查询次数：{{item.times}}次</span>
              </li>
            </ul>
        </div>
        <div class="tjrc-search " :class="{tjrcsearcha : ischange}" @mouseover="ischangetrue()" @mouseleave="ischangefalse()" >
            <div class="search-icon"><img src="../../assets/img/search-icon.png"> </div>
            <input class="search-input" placeholder="请输入关键字" v-model="input"    @input="inputlist()"/>
            <div class="searchlist" v-if="searchliststatus">
                <ul>
                  <li>指标：</li>
                  <li  v-for="(item,index) in searchlistzb"
                        :key="index"
                        @click="listcheck(item,index)"
                    >
                      {{item.resName}}
                    </li>
                    <li>文章：</li>
                  <li  v-for="(item,index) in searchlistwz"
                        :key="index"
                        @click="wzlistcheck(item)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
            </div>
        </div>
        <div style="width:994px;display: inline-block;margin-top: 30px;float: left;">
        <div class="kscx-title">
            <div class="kscx-name">
              <img src="../../assets/img/kscx-icon.png">
              <span>快速查询</span>
            </div>
            <span class="jdsj" :class="{isactive : pdtype==2}" @click="jdshow()"><i class="ileft"></i>进度数据<i class="iright"></i></span>
            <span class="ndsj" :class="{isactive : pdtype==1}" @click="yearshow()"><i class="ileft"></i>年度数据<i class="iright"></i></span>    
            <a @click="listcheck()"><img src="../../assets/img/more.png"></a>
        </div>
        <div class="kscx-content" v-if="pdtype==1">
          <ul>
                    <li  v-for="(item,index) in yearlist"
                        :key="index"
                        herf=""
                        @click="listcheck(item,index)"
                    >
                      <i></i>{{item.resName}}
                    </li>
          </ul>
        </div>
        <div class="kscx-content" v-if="pdtype==2">
          <ul>
                    <li  v-for="(item,index) in jdlist"
                        :key="index"
                        @click="listcheck(item,index)"
                    >
                      <i></i>{{item.resName}}
                    </li>
          </ul>
        </div>
        </div>
        <div style="width:100%;display: inline-block; float: left;">
        <div class="kshtb-title">
            <img src="../../assets/img/kshtb-icon.png">
            <span>可视化图表</span>
        </div>
        </div>
        <div class="kshtb-content">
            <div class="kshtb-first">
                  <div class="myChart" id="myChart0" ref="myChart0" style="margin-left:0px"></div>
                  <div class="myChart" id="myChart1" ref="myChart1"></div>
                  <div class="myChart" id="myChart2" ref="myChart2"></div>
            </div>
            <div class="kshtb-second">
                  <div class="myChart" id="myChart3" ref="myChart3" style="margin-left:0px"></div>
                  <div class="myChart" id="myChart4" ref="myChart4"></div>
                  <div class="myChart" id="myChart5" ref="myChart5"></div>
            </div>
        </div>
        <div class="wxzl-name">
        <div class="wxzl-title">
            <img src="../../assets/img/wxzl-a.png">
            <span>文献资料</span>
             
        </div>
        <a @click="wenzhangcheck()"><img src="../../assets/img/more.png"></a>
        </div>
        <div class="wxzl-content">
                  <div class="wenzhang"  style="margin-left:0px" @click="wzcheck(0)"><img src="../../assets/img/wz1.png"><span>{{wzlist[0].resName}}</span></div>
                  <div class="wenzhang" @click="wzcheck(1)"><img src="../../assets/img/wz2.png"><span>{{wzlist[1].resName}}</span></div>
                  <div class="wenzhang" @click="wzcheck(2)"><img src="../../assets/img/wz3.png"><span>{{wzlist[2].resName}}</span></div>
        </div>
      </div>
      <div class="foot">
          <span style="margin-top:35px">郴州市统计局</span> 
          <span>技术支持：浙江鸿程计算机系统有限公司</span>
      </div>
  </div>
</template>
<script>
import echarts from "echarts";
import {headerlist,chartsdata,searchdata,searchtop} from '@/api/index.js'
export default {
  data(){
      return{
        d0: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        d1: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        d2: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        d3: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        d4: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        d5: {
                title: '地区生产总值',
                xData: [],    
                yData1:[],
                yData2:[],
                data1unit:'',
                data2unit:'',
                data1name:'',
                data2name:'',
            },
        wzlist:[{
            resName:''
        },
        {
            resName:''
        },
        {
            resName:''
        },
        ],
        k:[null,null,null],
        pdtype: 2,
        headerlist:'',
        searchtop:'',
        current:'0',
        input:'',
        ischange:false,
        jdlist:'',
        yearlist:'',
        searchlistzb:'',
        searchlistwz:'',
        searchliststatus:false,
        searchliststatusnone:false,
      }
  },
  mounted(){
    //this.getheaderlist()
    this.getyearandjdlist()
    this.getsearchtop()
    this.getchartsdata()
    this.getwenzhanglist()
    console.log(this.k.length+'k.length')
    //this.draw()
  },
  methods:{
    listcheckS (id) {
      this.$store.commit('indicatorId', id);
      this.$router.push({path:'/dataQuery', query: {id: '1'}}) // 默认传一个id为1表示是从统计热词跳转的
    },
    listcheck(item){
      console.log(item)
      this.$store.commit('getindicatordata',item);
      this.$router.push({path:'/dataQuery',query:{type: this.pdtype}});
    },
    wenzhangcheck(){
      this.$router.push({path:'/statisticalInfo'});
    },
    yearshow(){
      this.pdtype=1;
    },
    jdshow(){
      this.pdtype=2;
    },
    getwenzhanglist(){
      headerlist({resourceType:'2'})
      .then(res=>{
        this.wzlist=res.data.data;
      })
    },
    getyearandjdlist(){
      headerlist({itemDm:'ndsj',resourceType:'1'})
      .then(res=>{
        this.yearlist=res.data.data;
      })
      headerlist({itemDm:'jdsj',resourceType:'1'})
      .then(res=>{
        this.jdlist=res.data.data;
      })
    },
    inputlist(){
      if(this.input==''){
          this.searchliststatus=false
      }
      else{
        this.searchliststatus=true
        searchdata({resourceName:this.input,resourceType:'1'})
        .then(res=>{
            
            this.searchlistzb=res.data.data
        })
        searchdata({resourceName:this.input,resourceType:'2'})
        .then(res=>{
          
            this.searchlistwz=res.data.data
        })
      }

    },
    ischangetrue(){
      this.ischange= true
    },
    ischangefalse(){
      this.ischange= false
      this.input = ''
      this.searchliststatus=false
    },
    searchcheck(item,index){

    },
    getheaderlist(){
      headerlist({itemDm:'kshtb',resourceType:'1'})
      .then(res=>{
        this.headerlist=res.data.data
        this.check(this.headerlist[0],0)
      })
      
    },
    getchartsdata(){
      chartsdata()
      .then(res=>{
         this.d0.xData =[];
         this.d0.yData1 =[];
         this.d0.yData2 = [];
         this.d1.xData =[];
         this.d1.yData1 =[];
         this.d1.yData2 = [];
         this.d2.xData =[];
         this.d2.yData1 =[];
         this.d2.yData2 = [];
         this.d3.xData =[];
         this.d3.yData1 =[];
         this.d3.yData2 = [];
         this.d4.xData =[];
         this.d4.yData1 =[];
         this.d4.yData2 = [];
         this.d5.xData =[];
         this.d5.yData1 =[];
         this.d5.yData2 = [];
        for(var i=res.data0.data.length-1;i>-1;i--){
          this.d0.xData.push(res.data0.data[i].timecode)
          this.d0.title = res.data0.data[0].indicatorName
          if(res.data0.data[i].type[0]=='line'){
            this.d0.yData1.push(res.data0.data[i].data[1])
            this.d0.yData2.push(res.data0.data[i].data[0])
            this.d0.data1unit = res.data0.data[0].unit[1]
            this.d0.data2unit = res.data0.data[0].unit[0]
            this.d0.data1name = res.data0.data[0].cal[1]
            this.d0.data2name = res.data0.data[0].cal[0]
          }
          else{
            this.d0.yData1.push(res.data0.data[i].data[0])
            this.d0.yData2.push(res.data0.data[i].data[1])
            this.d0.data1unit = res.data0.data[0].unit[0]
            this.d0.data2unit = res.data0.data[0].unit[1]
            this.d0.data1name = res.data0.data[0].cal[0]
            this.d0.data2name = res.data0.data[0].cal[1]
          }
          
        }
        for(var i=res.data1.data.length-1;i>-1;i--){
          this.d1.xData.push(res.data1.data[i].timecode)
          this.d1.title = res.data1.data[0].indicatorName
          if(res.data1.data[i].type[0]=='line'){
            this.d1.yData1.push(res.data1.data[i].data[1])
            this.d1.yData2.push(res.data1.data[i].data[0])
            this.d1.data1unit = res.data1.data[0].unit[1]
            this.d1.data2unit = res.data1.data[0].unit[0]
            this.d1.data1name = res.data1.data[0].cal[1]
            this.d1.data2name = res.data1.data[0].cal[0]
          }
          else{
            this.d1.yData1.push(res.data1.data[i].data[0])
            this.d1.yData2.push(res.data1.data[i].data[1])
            this.d1.data1unit = res.data1.data[0].unit[0]
            this.d1.data2unit = res.data1.data[0].unit[1]
            this.d1.data1name = res.data1.data[0].cal[0]
            this.d1.data2name = res.data1.data[0].cal[1]
          }
          
        }
        for(var i=res.data2.data.length-1;i>-1;i--){
          this.d2.xData.push(res.data2.data[i].timecode)
          this.d2.title = res.data2.data[0].indicatorName
          if(res.data2.data[i].type[0]=='line'){
            this.d2.yData1.push(res.data2.data[i].data[1])
            this.d2.yData2.push(res.data2.data[i].data[0])
            this.d2.data1unit = res.data2.data[0].unit[1]
            this.d2.data2unit = res.data2.data[0].unit[0]
            this.d2.data1name = res.data2.data[0].cal[1]
            this.d2.data2name = res.data2.data[0].cal[0]
          }
          else{
            this.d2.yData1.push(res.data2.data[i].data[0])
            this.d2.yData2.push(res.data2.data[i].data[1])
            this.d2.data1unit = res.data2.data[0].unit[0]
            this.d2.data2unit = res.data2.data[0].unit[1]
            this.d2.data1name = res.data2.data[0].cal[0]
            this.d2.data2name = res.data2.data[0].cal[1]
          }
          
        }
        for(var i=res.data3.data.length-1;i>-1;i--){
          this.d3.xData.push(res.data3.data[i].timecode)
          this.d3.title = res.data3.data[0].indicatorName
          if(res.data3.data[i].type[0]=='line'){
            this.d3.yData1.push(res.data3.data[i].data[1])
            this.d3.yData2.push(res.data3.data[i].data[0])
            this.d3.data1unit = res.data3.data[0].unit[1]
            this.d3.data2unit = res.data3.data[0].unit[0]
            this.d3.data1name = res.data3.data[0].cal[1]
            this.d3.data2name = res.data3.data[0].cal[0]
          }
          else{
            this.d3.yData1.push(res.data3.data[i].data[0])
            this.d3.yData2.push(res.data3.data[i].data[1])
            this.d3.data1unit = res.data3.data[0].unit[0]
            this.d3.data2unit = res.data3.data[0].unit[1]
            this.d3.data1name = res.data3.data[0].cal[0]
            this.d3.data2name = res.data3.data[0].cal[1]
          }
          
        }
        for(var i=res.data4.data.length-1;i>-1;i--){
          this.d4.xData.push(res.data4.data[i].timecode)
          this.d4.title = res.data4.data[0].indicatorName
          if(res.data4.data[i].type[0]=='line'){
            this.d4.yData1.push(res.data4.data[i].data[1])
            this.d4.yData2.push(res.data4.data[i].data[0])
            this.d4.data1unit = res.data4.data[0].unit[1]
            this.d4.data2unit = res.data4.data[0].unit[0]
            this.d4.data1name = res.data4.data[0].cal[1]
            this.d4.data2name = res.data4.data[0].cal[0]
          }
          else{
            this.d4.yData1.push(res.data4.data[i].data[0])
            this.d4.yData2.push(res.data4.data[i].data[1])
            this.d4.data1unit = res.data4.data[0].unit[0]
            this.d4.data2unit = res.data4.data[0].unit[1]
            this.d4.data1name = res.data4.data[0].cal[0]
            this.d4.data2name = res.data4.data[0].cal[1]
          }
          
        }
        for(var i=res.data5.data.length-1;i>-1;i--){
          this.d5.xData.push(res.data5.data[i].timecode)
          this.d5.title = res.data5.data[0].indicatorName
          if(res.data5.data[i].type[0]=='line'){
            this.d5.yData1.push(res.data5.data[i].data[1])
            this.d5.yData2.push(res.data5.data[i].data[0])
            this.d5.data1unit = res.data5.data[0].unit[1]
            this.d5.data2unit = res.data5.data[0].unit[0]
            this.d5.data1name = res.data5.data[0].cal[1]
            this.d5.data2name = res.data5.data[0].cal[0]
          }
          else{
            this.d5.yData1.push(res.data5.data[i].data[0])
            this.d5.yData2.push(res.data5.data[i].data[1])
            this.d5.data1unit = res.data5.data[0].unit[0]
            this.d5.data2unit = res.data5.data[0].unit[1]
            this.d5.data1name = res.data5.data[0].cal[0]
            this.d5.data2name = res.data5.data[0].cal[1]
          }
          
        }

        // this.d.data1unit = res.data.data[0].unit[0]
        // this.d.data2unit = res.data.data[0].unit[1]
        // this.d.data1name = res.data.data[0].cal[0]
        // this.d.data2name = res.data.data[0].cal[1]
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d0.yData1.length; i++) {
                  if (this.d0.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d0.yData2.length; i++) {
                  if (this.d0.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar0(this.d0)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  this.drawbar0(this.d0)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline0(this.d0)
                  break;
                }
                else{
                  this.draw0(this.d0)
                  break;
                }
        }
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d1.yData1.length; i++) {
                  if (this.d1.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d1.yData2.length; i++) {
                  if (this.d1.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar1(this.d1)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  this.drawbar1(this.d1)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline1(this.d1)
                  break;
                }
                else{
                  this.draw1(this.d1)
                  break;
                }
        }
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d2.yData1.length; i++) {
                  if (this.d2.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d2.yData2.length; i++) {
                  if (this.d2.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar2(this.d2)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  console.log(this.d2)
                  this.drawbar2(this.d2)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline2(this.d2)
                  break;
                }
                else{
                  this.draw2(this.d2)
                  break;
                }
        }
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d3.yData1.length; i++) {
                  if (this.d3.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d3.yData2.length; i++) {
                  if (this.d3.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar3(this.d3)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  this.drawbar3(this.d3)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline3(this.d3)
                  break;
                }
                else{
                  this.draw3(this.d3)
                  break;
                }
        }
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d4.yData1.length; i++) {
                  if (this.d4.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d4.yData2.length; i++) {
                  if (this.d4.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar4(this.d4)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  this.drawbar4(this.d4)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline4(this.d4)
                  break;
                }
                else{
                  this.draw4(this.d4)
                  break;
                }
        }
        while (true){
                var flag = true;
                var flag1 = true;
                for (var i = 0; i < this.d5.yData1.length; i++) {
                  if (this.d5.yData1[i] != null) {
                  flag = false;
                  break;
                  }
                }
                for (var i = 0; i < this.d5.yData2.length; i++) {
                  if (this.d5.yData2[i] != null) {
                  flag1 = false;
                  break;
                  }
                }
                if (flag==true&&flag1==true) {
                  this.drawbar5(this.d5)
                  break;
                  }
                else if(flag==false&&flag1==true){
                  this.drawbar5(this.d5)
                  break;
                }
                else if(flag==true&&flag1==false){
                  this.drawline5(this.d5)
                  break;
                }
                else{
                  this.draw5(this.d5)
                  break;
                }
        }
        

      })
      
    },
    getsearchtop(){
      searchtop()
      .then(res=>{
        this.searchtop=res.data
      })
    },
    wzcheck(index){
           this.$router.push({ path:'/article',query:{id:this.wzlist[index].resoruceId,}}); 
      },
    wzlistcheck(item){
           this.$router.push({ path:'/article',query:{id:item.resoruceId,}}); 
      },
    draw0(data) {
        console.log(data)
        let myChart0 = this.$echarts.init(this.$refs.myChart0);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(0, 101, 192, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(1, 139, 255, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart0.setOption(option,true);

    },
    drawline0(data) {
        console.log(data)
        let myChart0 = this.$echarts.init(this.$refs.myChart0);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(0, 101, 192, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart0.setOption(option,true);

    },
    drawbar0(data) {
        console.log(data)
        let myChart0 = this.$echarts.init(this.$refs.myChart0);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(1, 139, 255, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart0.setOption(option,true);

    },
    draw1(data) {
        console.log(data)
        let myChart1 = this.$echarts.init(this.$refs.myChart1);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(135, 196, 228, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(79, 103, 207, 1)',
                  barWidth:'14',
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                  yAxisIndex: 0,
                },
            ],
        };
        myChart1.setOption(option,true);

    },
    drawline1(data) {
        console.log(data)
        let myChart1 = this.$echarts.init(this.$refs.myChart1);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(135, 196, 228, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(250, 204, 21, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart1.setOption(option,true);

    },
    drawbar1(data) {
        console.log(data)
        let myChart1 = this.$echarts.init(this.$refs.myChart1);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(79, 103, 207, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart1.setOption(option,true);

    },
    draw2(data) {
        console.log(data)
        let myChart2 = this.$echarts.init(this.$refs.myChart2);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(246, 174, 73, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(169, 135, 227, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart2.setOption(option,true);

    },
    drawline2(data) {
        console.log(data)
        let myChart2 = this.$echarts.init(this.$refs.myChart2);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(246, 174, 73, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart2.setOption(option,true);

    },
    drawbar2(data) {
        console.log(data)
        let myChart2 = this.$echarts.init(this.$refs.myChart2);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(169, 135, 227, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart2.setOption(option,true);

    },
    draw3(data) {
        console.log(data)
        let myChart3 = this.$echarts.init(this.$refs.myChart3);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(83, 95, 147, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(57, 206, 164, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart3.setOption(option,true);

    },
    drawline3(data) {
        console.log(data)
        let myChart3 = this.$echarts.init(this.$refs.myChart3);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(83, 95, 147, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart3.setOption(option,true);

    },
    drawbar3(data) {
        console.log(data)
        let myChart3 = this.$echarts.init(this.$refs.myChart3);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(57, 206, 164, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart3.setOption(option,true);

    },
    draw4(data) {
        console.log(data)
        let myChart4 = this.$echarts.init(this.$refs.myChart4);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(202, 91, 91, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(254, 183, 103, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart4.setOption(option,true);

    },
    drawline4(data) {
        console.log(data)
        let myChart4 = this.$echarts.init(this.$refs.myChart4);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(202, 91, 91, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart4.setOption(option,true);

    },
    drawbar4(data) {
        console.log(data)
        let myChart4 = this.$echarts.init(this.$refs.myChart4);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(254, 183, 103, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart4.setOption(option,true);

    },
    draw5(data) {
        console.log(data)
        let myChart5 = this.$echarts.init(this.$refs.myChart5);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:function (params,ticket,callback) {
                      console.log(data+'zxxxx')
                       var unit = [data.data2unit,data.data1unit];
                       var res = params[0].name;
                      for (let i = 0, l = params.length; i < l; i++) {
                        if(unit[0]==null){
                           res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[1];
                        }
                       else if(unit[1]==null){
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[0];
                       }
                       else{
                         res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit[i];
                       }
                     }
                       return res
                     }
                  //'{b}<br/>{a0}:{c0}'+this.d.data2unit+'<br/>{a1}:{c1}'+this.d.data1unit+'<br/>'
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                       formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            {
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                         formatter:'{value}'+data.data2unit,
                        // formatter: function (params) {
                        //         return params+this.d.data2unit;
                        //     },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(84, 101, 181, 1)',
                   yAxisIndex:1,
                  symbol: 'none',
                },
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(233, 119, 135, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart5.setOption(option,true);

    },
    drawline5(data) {
        console.log(data)
        let myChart5 = this.$echarts.init(this.$refs.myChart5);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
              },
            },
             grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data2unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data2unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
               { name:data.data2name,
                  type : 'line',
                  data : data.yData2,
                  color: 'rgba(84, 101, 181, 1)',
                  symbol: 'none',
                },
            ],
        };
        myChart5.setOption(option,true);

    },
    drawbar5(data) {
        console.log(data)
        let myChart5 = this.$echarts.init(this.$refs.myChart5);
        let option = {
            title : {
              text:data.title,
              x:'center',
              y:'10px',
              textStyle: {
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 'normal',
                color:'rgba(0, 18, 35, 1)',
                },
            },
            grid:{
                    left:'1%',
                    right:'1%',
                    bottom:'2%',
                    containLabel:true
             },
            // tooltip : {
            //     trigger: 'axis'
            // },
            tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br/>{a0}:{c0}'+data.data1unit
          },
            // legend: {
            //     data: this.legend
            // },
            calculable : true,
            xAxis : [
                {   
                  axisTick:{
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                   axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        }
                    },
                    type : 'category',
                    data : data.xData,
                },
            ],
            yAxis : [
                {
                  name:'单位：'+data.data1unit,
                  nameLocation:'end',
                  nameTextStyle:{
                      color:"rgba(157, 177, 213, 1)", 
                  },
                axisTick:{
                    show: false
                },
                axisLabel: {
                        show: true,
                        textStyle: {
                        color: 'rgba(44, 77, 133, 1)',
                        fontsize:'20px',
                        },
                        formatter: function (params) {
                                return params;
                            },
                    },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(220, 223, 230, 1)', // 颜色
                    }
                },
                splitLine:{
						　　　　show:false
						　　 }

            },
            
            ],
            series: [
                { name:data.data1name,
                  type : 'bar',
                  data : data.yData1,
                  // itemStyle : { normal: {label : {show: true,position: 'top',}}},
                  color: 'rgba(233, 119, 135, 1)',
                  barWidth:'14',
                  yAxisIndex: 0,
                  itemStyle: {    // 图形的形状
                    barBorderRadius: [14, 14, 0 ,0]
                  },
                },
            ],
        };
        myChart5.setOption(option,true);

    },
  },
}
</script>

<style lang="scss">
    .index{
      width: 100%;
      height: auto;
      overflow-y: hidden;
      overflow-x: hidden;
      
      .index-header{
        width: 100%;
        height: 490px;
        background-image: url(../../assets/img/bg.png);
        position: relative;
        background-size: 100% 100%; 
        .header-charts{
              position: relative;
              margin-top: 50px; 
              height: 315px;
              width: 994px;
              left: calc(50% - 497px);
              float: left;
              .myChart{
                  width: 794.5px;
                  height: 315px;
                  background-color: rgba(255,255,255,.2);
                  display: inline-block;
              }
              .header-list{
                position: relative;
                width: 199.5px;
                display: inline-block;
                height: 315px;
                float: left;
                overflow: hidden;
                .scrollhidden{
                    position: relative;
                    width: 216.5px;
                    display: inline-block;
                    height: 315px;
                    overflow-y: scroll;
                    float: left;
                    ul{
                      margin: 0;
                      padding: 0;
                      li{
                        list-style: none;
                        height: 63px;
                        line-height: 63px;
                        font-size: 16.8px;
                        color: #fff;
                        text-align: center;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        cursor:pointer;
                      }
                      .active{
                        background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.17) 100%);
                      }
                    }
                }
                
              }
        }
        
        
      }
      .search-style{
        position:absolute;
        top:480px;
        height: 120px;
        width: 994px;
        left:-webkit-calc(50% - 497px); 
        left:-moz-calc(50% - 497px); 
        left:calc(50% - 497px);
        //margin:0 auto;
        background-color: #fff;
        //z-index: 99;
        .input-style{
          position: relative;
          //margin：35px;
          margin: 35px auto;
          height: 50px;
          width: 560px;
          border-radius: 50px;
          box-shadow:0px 10px 30px 0px rgba(0,44,87,0.1);
          .searchlist{
            width: 560px;
            background-color: #fff;
            max-height: 210px;
            overflow: hidden;
            overflow-y: scroll;
            position: absolute;
            border-radius: 20px;
            box-shadow:0px 10px 30px 0px rgba(0,44,87,0.1);
            ul{
              margin: 0;
              padding: 0;
              li{
                list-style: none;
                width: 510px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                background-color: #fff;
                padding-left: 20px;
                border-bottom: 1px solid #ccc;
                cursor:pointer;
              }
              li:hover{
                    background-color: #f5f5f5;
                  }
            }
          }
          input{
            border:0;
            width: 450px;
            height: 48px;
            margin-left: 25px;
            outline:none;
          }
          .search-button{
            float: right;
            width: 40px;
            height: 40px;
            border-radius: 40px;
            margin: 5px;
            background-color: #0067FF;
            img{
              width: 20px;
              height: 20px;
              margin: 10px;
            }
          }
        }
        }
        .content-tjrc{
          width: 994px;
          margin: 0 auto;
          height: auto;
          margin-top: 35px;
          .tjrc-title{
              width: 168px;
              height: 42px;
              background: rgba(93,175,244,1);
              border-radius: 0 21px 0 0;
              color: #fff;
            img{
              width: 28px;
              height: 28px;
              float: left;
              margin: 7px 7px 7px 14px;
            }
            span{
              font-size: 18px; 
              height: 42px;
              line-height: 42px;
            }
          }
          .tjrc-zb{
                width: 820px;
                height: 175px;
                display: inline-block;
                margin-top: 0px;
                background: #fff;
                float: left;
            ul{
              margin: 20px;
              padding: 0;
              float: left;
              li{
                width: 156px;
                display: inline-block;
                margin: 10px 0;
                float: left;
                span{
                  color: rgba(55, 67, 117, 1);
                  font-size: 17px;
                  display: block;
                  width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                span:nth-child(2){
                  display: block;
                  color: rgba(169, 176, 198, 1);
                  font-size: 15px;
                  width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
            
              .bg1{
                background-image: url(../../assets/img/tjbg1.png);
                background-size: 100% 100%;
              }
              .bg2{
                background-image: url(../../assets/img/tjbg2.png);
                background-size: 100% 100%;
              }
              .bg3{
                background-image: url(../../assets/img/tjbg3.png);
                background-size: 100% 100%;
              }
              .bg4{
                background-image: url(../../assets/img/tjbg4.png);
                background-size: 100% 100%;
              }
              .bg5{
                background-image: url(../../assets/img/tjbg5.png);
                background-size: 100% 100%;
              }
              .bg6{
                background-image: url(../../assets/img/tjbg6.png);
                background-size: 100% 100%;
              }
          }
          .tjnj-title{
            width: 252px;
            height: 60px;
            display: inline-block;
            img{
              width: 40px;
              height: 40px;
              margin-top: 10px;
              float: left;
            }
            span{
              font-size: 18px;
              height: 60px;
              line-height: 60px;
            }
            a{
              float: right;
              height: 60px;
              line-height: 60px;
              text-decoration:none;
              color: #0067FF;
              img{
                    float: right;
                    width: 4px;
                    height: 8px;
                    margin-top: 26px;
                    margin-left: 3px;
              }
            }
          }
          .tjnj-pic{
            width: 100%;
            height: 350px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .tjrc-search{
              width: 174px;
              float: left;
              height: 175px;
              display: inline-block;
              background: url(../../assets/img/search-bg.png);
              background-size:100% 100%; 
              position: absolute;
              border-radius: 0 20px 0 0;
              .search-icon{
                margin-top: 42px;
                width: 100%;
                text-align: center;
                img{
                  width: 42px;
                }
              }
              .search-input{
                    background-color: transparent;
                    border: 0;
                    color: #fff;
                    text-align: center;
                     :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                                color: #fff;
                            }

                            ::-moz-placeholder { /* Mozilla Firefox 19+ */
                                color: #fff;
                            }

                            :-ms-input-placeholder{
                                color: #fff;
                            }

                            ::-webkit-input-placeholder{
                                color: #fff;
                            }
                            &::placeholder {
                    color:#fff;
        }


              }
              .searchlist{
                float: left;
                width: 287px;
                height: 90px;
                margin: 0 14px;
                border-top: 1px solid #fff;
                background: rgba(255,255,255,.14);
                ul{
                  margin: 0;
                  padding: 0 0 0 10px;
                  overflow-y: scroll;
                  height: 90px;
                  li{
                    width: 100%;
                    height: 18px;
                    line-height: 18px;
                    color: #fff;
                    overflow: hidden;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                  li:hover{
                    background-color: rgba(255,255,255,.24)
                  }
                }
              }
          }
          .tjrcsearcha{
            width: 315px;
            .search-icon{
                margin-top: 10px;
                width: 100%;
                text-align: center;
                img{
                  width: 30px;
                }
              }
            .search-input{
                width: 277px;
                background: rgba(255,255,255,.14);
                height: 30px;
                text-align: left;
                padding-left: 10px;
                margin: 0 14px;
            }
          }
          .kscx-title{
            width: 994px;
            height: 42px;
            display: inline-block;
            float: left;
            line-height: 42px;
            .kscx-name{
              width: 168px;
              height: 42px;
              background: #5daff4;
              border-radius: 0 21px 0 0;
              color: #fff;
              float: left;
              display: inline-block;
              img{
                width: 28px;
                height: 28px;
                float: left;
                margin: 7px 7px 7px 14px;
              }
              span{
                font-size: 18px;
                height: 42px;
                line-height: 42px;
                float: left;
              }
            }
            a{
              float: right;
              height: 42px;
              line-height: 42px;
              text-decoration:none;
              cursor:pointer;
              background-color:rgba(93, 175, 244, 1);
              border-radius: 5px 5px 0 0; 
              img{
                    float: right;
                    width: 28px;
                    height: 28px;
                    margin: 7px;
              }
            }
            .ndsj{
              font-size: 14px;
              font-size: 14px;
              width: 80px;
              float: left;
              text-align: center;
              margin: 0 10px;
              cursor:pointer;
            }
            .jdsj{
              font-size: 14px;
              width: 80px;
              float: left;
              text-align: center;
              margin: 0 10px 0 20px;
              font-size: 14px;
              cursor:pointer;
            }
            .isactive{
              color: #0067FF;
              .ileft{
                    width: 4px;
                    height: 8px;
                    margin-top: 18px;
                    background-image: url(../../assets/img/right-icon.png);
                    float: left;
                    background-size: 100% 100%;
              }
              .iright{
                    width: 4px;
                    height: 8px;
                    margin-top: 18px;
                    background-size: 100% 100%;
                    background-image: url(../../assets/img/left-icon.png);
                    float: right;
              }
            }
          }
          .kscx-content{
             width: 994px;
             background-color: #fff;
             height: 175px;
             float: left;
             ul{
               width: 902px;
               margin: 18px 46px 18px 46px;
               padding: 0;
               li{
                list-style: disc!important;
                width: 225.5px;
                display: inline-block;
                text-align: left;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                margin-bottom: 13px;
                cursor:pointer;
                i{
                  width: 6px;
                  height: 6px;
                  background-color: rgba(0, 103, 255, 1);
                  float: left;
                  border-radius: 5px;
                  margin-top: 11px;
                  margin-right: 10px;
                }
               }
               li:hover{
                 color: rgba(0, 103, 255, 1);
               }
             }
          }
          .kshtb-title{
              width: 168px;
              height: 42px;
              background: rgba(93,175,244,1);
              border-radius: 0 21px 0 0;
              color: #fff;
              display: inline-block;
              margin-top: 30px;
            img{
              width: 28px;
              height: 28px;
              float: left;
              margin: 7px 7px 7px 14px;
            }
            span{
              font-size: 18px; 
              height: 42px;
              line-height: 42px;
            }
          }
          .kshtb-content{
            .kshtb-first{
                  width: 100%;
                  height: 210px;
                  display: inline-block;
                  .myChart{
                    width: 308px;
                    height: 210px;
                    background-color: #fff;
                    display: inline-block;
                    margin-left: 35px;
                    float: left;
                  }
            }
            .kshtb-second{
                  width: 100%;
                  height: 210px;
                  display: inline-block;
                  margin-top: 21px;
                  .myChart{
                    width: 308px;
                    height: 210px;
                    background-color: #fff;
                    display: inline-block;
                    margin-left: 35px;
                    float: left;
                  }
            }

          }
          .wxzl-name{
            width: 994px;
            height: 42px;
            display: inline-block;
            float: left;
            line-height: 42px;
            margin-top: 30px;
            .wxzl-title{
              width: 168px;
                height: 42px;
                background: rgba(93,175,244,1);
                border-radius: 0 21px 0 0;
                color: #fff;
                display: inline-block;
              img{
                width: 28px;
                height: 28px;
                float: left;
                margin: 7px 7px 7px 14px;
              }
              span{
                font-size: 18px; 
                height: 42px;
                line-height: 42px;
              }
            }
            a{
                float: right;
                height: 42px;
                line-height: 42px;
                text-decoration: none;
                cursor: pointer;
                background-color: #5daff4;
                border-radius: 5px 5px 0 0;
                img{
                  float: right;
                  width: 28px;
                  height: 28px;
                  margin: 7px;
                }
              }
          }
        .wxzl-content{
                  width: 100%;
                  height: 231px;
                  display: inline-block;
                  .wenzhang{
                    width: 308px;
                    height: 231px;
                    background-color: #fff;
                    display: inline-block;
                    margin-left: 35px;
                    float: left;
                    cursor: pointer;
                    img{
                      width: 308px;
                    }
                    span{
                      width: 100%;
                      height: 40px;
                      line-height: 40px;
                      text-align: center;
                      display: inline-block;
                      font-weight: bold;
                      color: rgba(0,18,35,1);
                    }
                  }
        }
        }
    }
    .foot{
      width: 100%;
      height: 140px;
      background: linear-gradient(360deg,rgba(37,122,214,1) 0%,rgba(93,175,244,1) 100%);
      margin-top: 50px;
      span{
        height: 35px;
        width: 100%;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
        float: left;
        color: #fff;
      }
    }
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue